import React from 'react';
import { IAuditFileProcessing } from '../interfaces/IAuditoriaEntradaDados';
import AuditMessage from './AuditMessage';

interface Props {
  processing?: IAuditFileProcessing;
  onReprocessar?: () => void;
  onVerResultado?: () => void;
  reprocessando?: boolean;
}

// Épico "Mensagens, Feedbacks e Gestão de Arquivos", seções 16-25 — barra de progresso e
// mensagens por status de processamento (QUEUED/STARTING/PROCESSING/COMPLETED/FAILED/RETRYING).
// O percentual e a etapa SEMPRE vêm do backend — este componente nunca calcula ou simula
// percentual (CA13/CA14 do Épico).
const AuditProcessingProgress: React.FC<Props> = ({ processing, onReprocessar, onVerResultado, reprocessando }) => {
  if (!processing) return null;

  if (processing.status === 'QUEUED') {
    return (
      <AuditMessage
        type='INFO'
        title='Aguardando processamento'
        message='O arquivo foi recebido e está na fila para processamento.'
      />
    );
  }

  if (processing.status === 'STARTING') {
    return (
      <AuditMessage
        type='INFO'
        title='Iniciando conciliação'
        message='Os dados estão sendo preparados para o processamento.'
      />
    );
  }

  if (processing.status === 'PROCESSING' || processing.status === 'RETRYING') {
    return (
      <div className='audit-progress-card'>
        <div className='audit-progress-title'>
          {processing.status === 'RETRYING' ? 'Reprocessando' : 'Processando Conciliação Bancária'} —{' '}
          {processing.progressPercentage}%
        </div>
        <div className='audit-progress-bar-track'>
          <div className='audit-progress-bar-fill' style={{ width: `${processing.progressPercentage}%` }} />
        </div>
        <div className='audit-progress-etapa'>{processing.statusMessage}</div>
      </div>
    );
  }

  if (processing.status === 'COMPLETED') {
    return (
      <div>
        <AuditMessage
          type='SUCCESS'
          title='Conciliação processada com sucesso'
          message='O processamento foi concluído e o resultado da auditoria está disponível.'
        />
        {onVerResultado && (
          <button type='button' className='btn btn-sm btn-light-primary mt-2' onClick={onVerResultado}>
            Ver Resultado
          </button>
        )}
      </div>
    );
  }

  if (processing.status === 'FAILED') {
    return (
      <div>
        <div className='audit-progress-card audit-progress-card-erro'>
          <div className='audit-progress-title'>
            Erro durante o processamento — {processing.progressPercentage}%
          </div>
          <div className='audit-progress-bar-track'>
            <div className='audit-progress-bar-fill audit-progress-bar-fill-erro' style={{ width: `${processing.progressPercentage}%` }} />
          </div>
          <div className='audit-progress-etapa'>
            {processing.errorMessage || 'Não foi possível concluir o processamento da conciliação.'}
          </div>
        </div>
        {onReprocessar && (
          <button type='button' className='btn btn-sm btn-warning mt-2' disabled={reprocessando} onClick={onReprocessar}>
            {reprocessando && <span className='spinner-border spinner-border-sm me-2' />}
            Reprocessar
          </button>
        )}
      </div>
    );
  }

  return null;
};

export default AuditProcessingProgress;
